<template>
  <v-toolbar flat>
    <div
      style="width: 150px" class="mr-2">
      <ejercicio-picker
        v-model="filtros.ejercicio"
        class="mr-2">
      </ejercicio-picker>
    </div>
    <div style="width: 350px" class="mr-2">
      <custom-text-field
        v-model="filtros.buscarTexto"
        label="Buscar..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
    </div>
    <filtros
      :contratos="listaContratos"
      :filtros="filtros">
    </filtros>
    <v-spacer></v-spacer>
    <v-tooltip
    v-if="mixValidaScopesActions(1)"
    top>
      <template
        v-slot:activator="{ on, attrs }">
        <custom-button
          label="Nuevo"
          iconText="mdi-plus"
          tipo="agregar"
          @click="nuevo"
          v-bind="attrs"
          v-on="on">
        </custom-button>
      </template>
      <span>
        Registrar nuevo contrato
      </span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import Filtros from './Filtros.vue';

export default {
  name: 'ToolBarContratos',
  props: {
    listaContratos: {
      type: Array,
      required: true,
    },
    expedientes: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    EjercicioPicker,
    Filtros,
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
    nuevo() {
      this.$emit('nuevoContrato');
    },
  },
};
</script>

<style lang="scss">
</style>
